<template>
  <div>
    <v-dialog v-model="localDialog" max-width="50%" class="z-10000">
      <v-card>
        <v-card-title v-if="localTitle" v-html="replaceKaigyo(localTitle)" />
        <v-card-text>
          <p v-if="localText" v-html="replaceKaigyo(localText)" />
          <p v-if="localErrorType" v-html="`Error: ${localErrorType}`" />
          <p v-if="localErrorMessage" v-html="`Details: ${replaceKaigyo(localErrorMessage)}`" />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <KtznAdminButton :isOutlined="true" :label="$t('ok')" data-ktznta="43" @onClick="localDialog = false" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { createComponent, PropType, value, watch } from "vue-function-api";
import { isEmpty } from "@/framework/utilities/isEmpty";
import { replaceKaigyo } from "@/framework/utilities/replaceKaigyo";
import KtznAdminButton from "@/framework/components/common/KtznAdminButton.vue";

type ErrorDialogControls = {
  dialog: boolean;
  title: string;
  text: string;
  errorType: string;
  errorMessage: string;
};

export default createComponent({
  props: ["dialogControls"] as any as PropType<{
    dialogControls: ErrorDialogControls;
  }>,
  components: {
    KtznAdminButton,
  },
  name: "ErrorDisplayDialog",
  setup(props, context) {
    const localDialog = value(false);
    const localTitle = value("");
    const localText = value("");
    const localErrorType = value("");
    const localErrorMessage = value("");
    const dialogState = (val: boolean) => (localDialog.value = val);

    watch(
      () => props.dialogControls as ErrorDialogControls,
      (newVal) => {
        if (newVal == null) return;
        localDialog.value = newVal.dialog;
        localText.value = newVal.text;
        localTitle.value = newVal.title;
        localErrorType.value = newVal.errorType;
        localErrorMessage.value = newVal.errorMessage;
        localErrorMessage.value = !isEmpty(localErrorMessage.value)
          ? localErrorMessage.value.replaceAll('"', "")
          : localErrorMessage.value;
      }
    );

    return {
      localText,
      localTitle,
      localDialog,
      localErrorType,
      localErrorMessage,
      dialogState,
      replaceKaigyo,
    };
  },
});
</script>

<style scoped>
.z-10000 {
  z-index: 10000;
}
</style>
